import { Navigate, useParams } from "react-router-dom";
import { useQuery, useReactiveVar } from "@apollo/client";
import { GET_GAM_CAMPAIGN_INFO } from "../../graphql/operations/campaignOperations/operations";
import { ComponentLoading } from "../../components/loading/ComponentLoading";
import { OptimisationPackageType } from "../../graphql/generated";
import {
  Box,
  Divider,
  HStack,
  VStack,
} from "@chakra-ui/react";
import { createContext } from "react";
import { useContext } from "react";
import { userDetailsVar } from "../../lib/cache";
import { FormSubSectionHeader } from "../../components/formSubSectionHeader/FormSubSectionHeader";
import { DetailsSummary } from "./DetailsSummary";
import { TargetDetailsSummary } from "./TargetDetailsSummary";

interface IGamCampaignSummary {
  gamCampaign: OptimisationPackageType;
}

const gamCampaignContext = createContext({} as IGamCampaignSummary);

export const useGamCampaignInfo = () => {
  return useContext(gamCampaignContext);
};

export const GamCampaignSummaryPage = () => {
    const currentUser = useReactiveVar(userDetailsVar);
    const { id: gamCampaignId } = useParams();

    if (!gamCampaignId) {
      return <Navigate to={"/404"} />;
    }

    const { data, loading, error } = useQuery(GET_GAM_CAMPAIGN_INFO, {
      variables: {
        id: gamCampaignId,
      },
      fetchPolicy: "cache-and-network",
    });

    if (!currentUser) {
      return <ComponentLoading text={"Loading page..."} />;
    }

    if (
      !(currentUser?.isStaff || currentUser?.agency.partner)
    ) {
      return <Navigate to={"/"} />;
    }

    if (loading && !data) {
      return <ComponentLoading text={"Loading your campaign information..."} />;
    }

    if (error) {
      return <Navigate to={"/404"} />;
    }

    const gamCampaignInfo: OptimisationPackageType = data.optimisationPackageInfo;

    return (
      <gamCampaignContext.Provider value={{ gamCampaign: gamCampaignInfo }}>
        <Box
          p={10}
          bg={"white"}
          borderRadius={"sm"}
          w={"100%"}
          height={"100%"}
          justifyContent={"center"}
        >
          <VStack align={"flex-start"}>
            {/* <Text ml={3} fontWeight={"medium"}> {"Details"}</Text> */}

            <FormSubSectionHeader label={"Details"} margin={"4"} />
            <Divider borderColor={"muted"} mb={1} ml={4} w={"100%"} />
              <HStack alignItems="flex-start" width="100%" height="100%" >
                <Box w={"100%"} p={2}>
                    <DetailsSummary variant="flex" />
                  </Box>
                <Box w={"100%"} p={2}>
                    <TargetDetailsSummary />
                </Box>
              </HStack>
          </VStack>
        </Box>
      </gamCampaignContext.Provider>
    );
}
